(function () {
  if (window.__creatorStoreInit) return;
  window.__creatorStoreInit = true;

  var DEFAULT_TITLE = 'Default Title';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- panel open / close ---------- */
  function openPanel(panel) {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('creator-panel-open');

    // Reflect the open creator in the URL so the page is shareable/linkable:
    // copying the address now gives a link that reopens this creator's shop.
    var card = panel.closest('.creator-card');
    var handle = card && card.getAttribute('data-creator-handle');
    if (handle) {
      try {
        // Use pathname (not just '#…') so any ?shop= query that opened the panel
        // is dropped, leaving a clean /#shop-<handle> address to share.
        history.replaceState(null, '', location.pathname + '#shop-' + encodeURIComponent(handle));
      } catch (e) {}
    }
  }

  function closePanel(panel) {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('creator-panel-open');
    var body = panel.querySelector('.creator-panel__body');
    if (body) body.scrollTop = 0;

    // Drop the #shop-… fragment so the URL matches the closed state.
    if ((location.hash || '').indexOf('#shop-') === 0) {
      try {
        history.replaceState(null, '', location.pathname + location.search);
      } catch (e) {}
    }
  }

  /* ---------- deep link: open a creator's panel straight from the URL ----------
     A shared link lands the visitor directly in that creator's slide-out shop.
     Two link forms are accepted, both keyed on the collection handle:
       • hash:  /#shop-<handle>            (what an opened panel writes for sharing)
       • query: /?shop=<handle>            (redirect-safe — used by the friendly
                                            /kayleigh → /?shop=… URL redirects)
     If the link opens on a page where the creator grid is behind the nav toggle
     (e.g. the home page), reveal the Creator Store view first. */
  function deepLinkHandle() {
    var hashMatch = (location.hash || '').match(/^#shop-(.+)$/);
    if (hashMatch) return decodeURIComponent(hashMatch[1]);
    var queryMatch = (location.search || '').match(/[?&]shop=([^&]+)/);
    if (queryMatch) return decodeURIComponent(queryMatch[1].replace(/\+/g, ' '));
    return null;
  }

  function openFromHash() {
    var handle = deepLinkHandle();
    if (!handle) return;

    var card = null;
    document.querySelectorAll('.creator-card').forEach(function (c) {
      if (c.getAttribute('data-creator-handle') === handle) card = c;
    });
    if (!card) return;

    var panel = card.querySelector('.creator-panel');
    if (!panel) return; // external creator (no in-page panel)

    // offsetParent is null when the card (or a parent view) is display:none.
    if (!card.offsetParent) {
      var creatorToggle = document.querySelector('.toggle-btn[data-filter="creator"]');
      if (creatorToggle) creatorToggle.click();
    }

    openPanel(panel);
  }

  /* ---------- inline buy controls (size + add to cart + buy now) ---------- */
  function initBuyBlocks(root) {
    (root || document).querySelectorAll('.creator-buy').forEach(function (buy) {
      if (buy._init) return;
      buy._init = true;

      var dataEl = buy.querySelector('.creator-buy__json');
      if (!dataEl) return;
      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      buy._data = data;
      buy._selected = {};

      // Size/variant option pickers are omitted on listings — default to the
      // first available variant (or the first variant) so Add to cart / Buy now
      // work directly; shoppers pick a specific option on the product page.
      var defaultVariant = null;
      for (var di = 0; di < data.variants.length; di++) {
        if (data.variants[di].available) {
          defaultVariant = data.variants[di];
          break;
        }
      }
      if (!defaultVariant) defaultVariant = data.variants[0];
      if (defaultVariant) {
        for (var oi = 0; oi < data.options.length; oi++) {
          buy._selected[oi] = defaultVariant.options[oi];
        }
      }

      updateState(buy);
    });
  }

  function selectValue(buy, btn) {
    var opt = btn.getAttribute('data-opt');
    buy.querySelectorAll('.creator-buy__value[data-opt="' + opt + '"]').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
    buy._selected[opt] = btn.getAttribute('data-val');
    updateState(buy);
  }

  function resolveVariant(buy) {
    var data = buy._data;
    for (var vi = 0; vi < data.variants.length; vi++) {
      var v = data.variants[vi];
      var match = true;
      for (var i = 0; i < data.options.length; i++) {
        var ov = data.options[i].values;
        if (ov.length === 1 && ov[0] === DEFAULT_TITLE) continue;
        if (buy._selected[i] == null || v.options[i] !== buy._selected[i]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function updateState(buy) {
    var v = resolveVariant(buy);
    var add = buy.querySelector('.creator-buy__add');
    var now = buy.querySelector('.creator-buy__now');
    var msg = buy.querySelector('.creator-buy__msg');
    if (msg) msg.textContent = '';
    buy._variant = v;
    var hasOptions = buy.querySelector('.creator-buy__value') != null;

    if (!v) {
      if (add) {
        add.disabled = true;
        add.textContent = hasOptions ? 'Select options' : 'Unavailable';
      }
      if (now) now.disabled = true;
      return;
    }
    if (v.available) {
      if (add) {
        add.disabled = false;
        add.textContent = 'Add to cart';
      }
      if (now) {
        now.disabled = false;
        now.textContent = 'Buy now';
      }
    } else {
      if (add) {
        add.disabled = true;
        add.textContent = 'Sold out';
      }
      if (now) now.disabled = true;
    }
  }

  function postAdd(buy) {
    var v = buy._variant;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res && res.status && res.status !== 200) throw new Error(res.description || 'Could not add to cart.');
        return res;
      });
  }

  function addToCart(buy) {
    var v = buy._variant;
    if (!v || !v.available) return;
    var add = buy.querySelector('.creator-buy__add');
    var msg = buy.querySelector('.creator-buy__msg');
    add.disabled = true;
    add.textContent = 'Adding…';
    postAdd(buy)
      .then(function () {
        add.disabled = false;
        add.textContent = 'Add to cart';
        if (msg) msg.innerHTML = 'Added to cart. <a href="/cart">View cart &rarr;</a>';
        updateCartCount();
      })
      .catch(function (err) {
        add.disabled = false;
        add.textContent = 'Add to cart';
        if (msg) msg.textContent = err && err.message ? err.message : 'Could not add to cart.';
      });
  }

  function buyNow(buy) {
    var v = buy._variant;
    if (!v || !v.available) return;
    var now = buy.querySelector('.creator-buy__now');
    var msg = buy.querySelector('.creator-buy__msg');
    now.disabled = true;
    now.textContent = 'Working…';
    postAdd(buy)
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        now.disabled = false;
        now.textContent = 'Buy now';
        if (msg) msg.textContent = err && err.message ? err.message : 'Could not start checkout.';
      });
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
          var span = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
          if (span) span.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      })
      .catch(function () {});
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.creator-panel__close');
    if (closeBtn) {
      var cp = closeBtn.closest('.creator-panel');
      if (cp) closePanel(cp);
      return;
    }

    var val = e.target.closest('.creator-buy__value');
    if (val) {
      var b1 = val.closest('.creator-buy');
      if (b1) selectValue(b1, val);
      return;
    }

    var add = e.target.closest('.creator-buy__add');
    if (add) {
      var b2 = add.closest('.creator-buy');
      if (b2) addToCart(b2);
      return;
    }

    var now = e.target.closest('.creator-buy__now');
    if (now) {
      var b3 = now.closest('.creator-buy');
      if (b3) buyNow(b3);
      return;
    }

    // Product card image/title inside the panel links to the real product page —
    // let it navigate normally.
    var cardLink = e.target.closest('.creator-shop-item .card-wrapper a');
    if (cardLink) return;

    // Any other click inside an open panel is left alone.
    if (e.target.closest('.creator-panel')) return;

    // Social links on the card navigate to their platforms.
    if (e.target.closest('.creator-card__social')) return;

    // Card → open its store panel, or navigate away for external shops.
    var card = e.target.closest('.creator-card');
    if (!card) return;
    e.preventDefault();
    if (card.getAttribute('data-external') === 'true') {
      var url = card.getAttribute('data-shop-url');
      if (url) window.location.href = url;
      return;
    }
    var panel = card.querySelector('.creator-panel');
    if (panel) openPanel(panel);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.creator-panel.is-open');
    if (open) closePanel(open);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initBuyBlocks();
    openFromHash();
  });
  window.addEventListener('hashchange', openFromHash);
  initBuyBlocks();
  openFromHash();
})();
